<template>
  <el-dialog
    :title="title"
    :visible.sync="localVisible"
    width="500px"
    :close-on-click-modal="false"
    append-to-body
    @close="handleClose"
  >
    <el-form ref="form" :model="formData" :rules="rules" label-width="100px">
      <el-row :gutter="5">
        <el-col :span="12">
          <el-form-item label="设施编码" prop="typeCode">
            <el-input v-model="formData.typeCode" placeholder="请输入设施编码" maxlength="20" :disabled="type === 'edit'"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="所属系统" prop="systemId">
            <el-select v-model="formData.systemId" placeholder="请选择" style="width: 100%" disabled>
              <el-option v-for="item in systemList" :key="item.uuid" :label="item.systemName" :value="item.uuid"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="设施名称" prop="typeName">
        <el-input v-model="formData.typeName" placeholder="请输入设施类型名称" maxlength="50"></el-input>
      </el-form-item>
      <el-form-item label="说明" prop="description">
        <el-input type="textarea" v-model="formData.description" :rows="3" placeholder="请输入设施说明" maxlength="200"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { deviceTypeService } from './deviceType.service';

export default {
  name: 'DeviceTypeDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'add'
    },
    initialData: {
      type: Object,
      default: () => ({})
    },
    systemList: {
      type: Array,
      default: () => []
    },
    currentSystemId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      localVisible: false,
      formData: {
        uuid: '',
        typeCode: '',
        typeName: '',
        systemId: '',
        description: ''
      },
      rules: {
        typeCode: [{ required: true, message: '请输入设施编码', trigger: 'blur' }],
        typeName: [{ required: true, message: '请输入设施名称', trigger: 'blur' }]
      },
      submitting: false
    };
  },
  computed: {
    title() {
      return this.type === 'add' ? '新增设施类型' : '编辑设施类型';
    }
  },
  watch: {
    visible(val) {
      this.localVisible = val;
      if (val) {
        this.initForm();
      }
    }
  },
  methods: {
    initForm() {
      if (this.type === 'edit' && this.initialData) {
        this.formData = {
          uuid: this.initialData.uuid,
          typeCode: this.initialData.typeCode,
          typeName: this.initialData.typeName,
          systemId: this.initialData.systemId,
          description: this.initialData.description
        };
      } else {
        this.formData = {
          uuid: '',
          typeCode: '',
          typeName: '',
          systemId: this.currentSystemId,
          description: ''
        };
      }
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },
    handleClose() {
      this.$emit('update:visible', false);
      this.$emit('close');
      this.$refs.form && this.$refs.form.resetFields();
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.submitting = true;
        const submitData = {
          ...this.formData,
          systemId: this.formData.systemId || this.currentSystemId,
          status: 1
        };

        deviceTypeService.saveDeviceType(submitData).then(() => {
          this.$message.success('保存成功');
          this.handleClose();
          this.$emit('success');
        }).finally(() => {
          this.submitting = false;
        });
      });
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .el-form-item {
  margin-bottom: 18px;
}

::v-deep .el-form-item__error {
  position: relative;
  top: 0;
  padding-top: 2px;
}
</style>
